import React from 'react';
import { NaturalDisasterAlertScreen } from '../../../components';
import { ContextProvider } from '../../../utils';
const NDAlertScreen = props => {
  return /*#__PURE__*/React.createElement(ContextProvider, null, /*#__PURE__*/React.createElement(NaturalDisasterAlertScreen, props));
};
export default /*#__PURE__*/React.memo(NDAlertScreen);
//# sourceMappingURL=index.js.map